import React, { useEffect, useState } from 'react';
//import { HashRouter as Router, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import { HashRouter as Router, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import HomePage from './components/HomePage/HomePage';
import SyllabusPage from './components/SyllabusPage/SyllabusPage';
// import InstructionsPage from './components/InstructionsPage/InstructionsPage';
// import ApplyOnlinePage from './components/ApplyOnlinePage/ApplyOnlinePage';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import { Container } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ExcelUploadComponent from './components/ExcelUploadComponent/ExcelUploadComponent';
import Registration from './components/Registration/Registration';
import Home from './components/Home/Home.js';
import AdmitCard from './components/AdmitCard/AdmitCard';
import ExamCenterSelection from './components/ExamSelection/ExamCenterSelection';
import EmployeeResults from './components/Result/EmployeeResults';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import SelectedExam from './components/SelectedExam/SelectedExam.js';
import EmployeeDashboard from './components/Dashboard/EmployeeDashboard.js';
import PageNotFound from './components/PageNotFound/PageNotFound.js';
import Allocation from './components/Admin/Allocation/Allocation.js';
import Result from './components/Admin/Result/Result.js';
import UploadNotice from './components/Admin/UploadNotice/UploadNotice.js';
import EventConfig from './components/Admin/EventConfig/EventConfig.js';
import Faqs from './components/Faqs/Faqs.js';
import Contact from './components/ContactPage/ContactPage.js';


// PrivateRoute component
const PrivateRoute = ({ element: Element, ...rest }) => {
  const token = localStorage.getItem('tokenId');
  return token ? <Element {...rest} /> : <Navigate to="/register" />;
};

const App = () => {
  const [successMessage, setMessage] = useState('');

  const handleCallback = (childData) => {
    setMessage(childData);
  };

  useEffect(() => {
    if (successMessage !== '') {
      withReactContent(Swal).fire({
        text: successMessage
      });
    }
  }, [successMessage]);

  return (
    <>
      <Router>
        {/* <Header /> */}
        <Container fluid style={{backgroundColor:"#f5f5f5"}}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/* <Route path="/login" element={<LoginPage />} /> */}
            <Route path="/syllabus" element={<SyllabusPage />} />
            <Route path="/upload_excel" element={<ExcelUploadComponent />} />
            <Route path="/faq" element={<Faqs/>} />
            <Route path="/contact" element={<Contact/>} />
            
            <Route path="/register" element={<Registration handleCallback={handleCallback} />} />

            {/* Private Routes */}
            <Route path="/dashboard" element={<PrivateRoute element={Home} />}>
              <Route path="centreselect" element={<PrivateRoute element={ExamCenterSelection} />} />
              <Route path="admitcard" element={<PrivateRoute element={AdmitCard} />} />
              <Route path="result" element={<PrivateRoute element={EmployeeResults} />} />
              <Route path="selectedexam" element={<PrivateRoute element={SelectedExam} />} />
              <Route path="employeeDashboard" element={<PrivateRoute element={EmployeeDashboard} />} />
              <Route path="uploadAllocation" element={<PrivateRoute element={Allocation} />} />
              <Route path="uploadResult" element={<PrivateRoute element={Result} />} />
              <Route path="uploadNotice" element={<PrivateRoute element={UploadNotice} />} />
              <Route path="event" element={<PrivateRoute element={EventConfig} />} />
            </Route>
            
            <Route path="*" element={<PageNotFound />} />
          </Routes>
          <Footer />
        </Container>
      </Router>
    </>
  );
};

export default App;
